<template>
  <section
    class="top-navigation sticky-top"
    :class="{ 'show-phone': showMenu }"
  >
    <div class="row custom-input">
      <div class="col-md-4">
        <label class="input-group mb-1">
          <span class="input-group-text me-3" id="basic-addon1">
            <BaseIcon name="search" />
          </span>
          <input
            type="text"
            ref="search"
            class="form-control"
            :placeholder="$t('global.search')"
            :aria-label="$t('global.search-alt')"
            v-model="q"
            id="search-bar"
          />
        </label>
      </div>
      <div class="col-md-4 mb-1">
        <DatePicker
          v-model="date"
          :onlyInRange="1"
          :range="true"
          :twoCalendars="true"
        />
      </div>
      <div class="col-md-4">
        <v-select
          v-model="warehouse"
          :options="
            warehouses.filter(
              (e) =>
                enabledWarehouses.indexOf(e.id) > -1 &&
                (e.is_closed !== true || showClosed)
            )
          "
          label="name"
          :aria-label="$t('global.filter-storage')"
          :placeholder="$t('global.storages')"
          :reduce="(o) => o.id"
          append-to-body
        >
          <template v-slot:selected-option="option">
            <BaseIcon name="shop" v-if="option.shop_id > 0" />
            <BaseIcon name="scissor" v-else-if="option.type === 2" />
            <BaseIcon
              name="buildings"
              v-else-if="option.fulfilment_app_id > 0"
            />
            <BaseIcon name="box" v-else-if="option.type === 3" />
            <BaseIcon name="delivery-info" v-else />
            <span class="ms-3">
              {{ option.name }}
            </span>
          </template>
          <template v-slot:option="option">
            <BaseIcon name="shop" v-if="option.shop_id > 0" />
            <BaseIcon name="scissor" v-else-if="option.type === 2" />
            <BaseIcon
              name="buildings"
              v-else-if="option.fulfilment_app_id > 0"
            />
            <BaseIcon name="box" v-else-if="option.type === 3" />
            <BaseIcon name="delivery-info" v-else />
            <span class="ms-3"> {{ option.name }} </span>
          </template>
        </v-select>
      </div>
    </div>
  </section>
</template>

<script>
import DatePicker from "./inputs/DatePicker";
import BaseIcon from "@/components/icons/BaseIcon";

export default {
  name: "TopBar",
  components: { BaseIcon, DatePicker },
  data() {
    let date = new Date();
    date.setDate(new Date().getDate() - 365);

    return {
      date: [date, new Date()],
      q: "",
    };
  },
  watch: {
    $route() {
      this.setDate();
    },
    date() {
      if (
        Array.isArray(this.date) &&
        Array.isArray(this.$store.state.topBar.date) &&
        this.date[0]?.getTime() ===
          new Date(this.$store.state.topBar.date[0]).getTime() &&
        this.date[1]?.getTime() ===
          new Date(this.$store.state.topBar.date[1]).getTime()
      ) {
        return;
      }
      this.$store.commit("setTopBar", { key: "date", value: this.date });
    },
    q(val, oldVal) {
      if (val === oldVal) return;
      if (this.q.length > 2) {
        this.$store.commit("setTopBar", { key: "q", value: this.q });
      } else {
        this.$store.commit("setTopBar", { key: "q", value: null });
      }
    },
    warehouses(val) {
      if (!val) return;
      let filteredVal = val.filter(
        (e) =>
          this.enabledWarehouses.indexOf(e.id) > -1 &&
          (e.is_closed !== true || this.showClosed)
      );
      if (filteredVal?.length == 1) {
        if (this.warehouse !== filteredVal[0].id) {
          this.warehouse = filteredVal[0].id;
        }
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", (event) => {
      if (
        event.target.nodeName !== "INPUT" &&
        event.ctrlKey &&
        event.key === "f"
      ) {
        this.$refs.search.focus();
        event.preventDefault();
      }
    });
    this.setDate();
  },
  computed: {
    showClosed() {
      return this.$store.state.showClosedWarehouses;
    },
    showMenu() {
      return this.$store.state.showSearchMenu;
    },
    warehouses() {
      let warehouses = [...this.$store.state.warehouses];
      return warehouses.sort((a, b) => {
        const companyDiff = a.company_id - b.company_id;
        if (companyDiff !== 0) {
          return companyDiff;
        } else {
          if (!a.shop_id && !a.fulfilment_app_id && a.type !== 2) {
            return -1;
          } else if (!b.shop_id && !b.fulfilment_app_id && b.type !== 2) {
            return 1;
          } else if (!a.shop_id && b.shop_id) {
            return 1;
          } else if (!b.shop_id && a.shop_id) {
            return -1;
          } else if (a.type !== 2 && b.type === 2) {
            return -1;
          } else if (b.type !== 2 && a.type === 2) {
            return 1;
          } else {
            return a.country_id - b.country_id;
          }
        }
      });
    },
    enabledWarehouses() {
      return this.$store.state.enabledWarehouses;
    },
    warehouse: {
      get() {
        return this.$store.state.topBar.warehouse;
      },
      set(value) {
        if (this.$store.state.topBar.warehouse !== value) {
          this.$store.commit("setTopBar", {
            key: "warehouse",
            value: value,
          });
        }
      },
    },
  },
  methods: {
    setDate() {
      console.log(this.$route);
      let newDate = null;
      if (this.$route.name === "Sales user") {
        let date = new Date();
        date.setDate(date.getDate() - 36525);
        const today = new Date();
        newDate = [date, today];
        console.log(date);
      } else if (
        this.$route.name === "Inventory analytics" ||
        this.$route.name === "Web analytics"
      ) {
        let date = new Date();
        date.setDate(date.getDate() - 30);
        const today = new Date();
        newDate = [date, today];
      }

      if (newDate) {
        if (
          !Array.isArray(this.date) ||
          this.date[0]?.getTime() !== newDate[0].getTime() ||
          this.date[1]?.getTime() !== newDate[1].getTime()
        ) {
          this.date = newDate;
          this.$store.commit("setTopBar", { key: "date", value: this.date });
        }
      }
    },
  },
};
</script>
